import {listUsers} from "@/services/api/app/google/recovery/recovery";
import {defaultPagination} from "@/services/pagination";

const defaultState = () => ({
  users: [],
  pagination: {
    ...defaultPagination(),
    sortBy: 'fullName',
    sortDescending: false
  },
  search: null,
});

export default {
  namespaced: true,
  actions: {
    listUsers({commit, state},) {
      return listUsers({
        pagination: state.pagination,
        search: state.search,
        filter: {
          "statuses": [
            1, 2, 4
          ]
        },
        module: 8
      })
        .then(({result, pagination}) => {
          commit('setUsers', result)
          commit('setPagination', pagination)
        })
    },
  },

  mutations: {
    setUsers(state, users) {
      state.users = users.map(user => {
        user.gmail = user.gMail;
        return user;
      });
    },
    setPagination(state, pagination) {
      state.pagination = pagination;
    },
    setSearch(state, search) {
      state.search = search;
    },
    resetPagination(state, {keepSort}) {
      if (keepSort) {
        state.pagination = {
          ...defaultPagination(),
          sortBy: state.pagination.sortBy,
          sortDescending: state.pagination.sortDescending,
        }
      } else {
        state.pagination = {
          ...defaultPagination(),
          sortBy: 'fullName',
          sortDescending: false
        };
      }
    },
    resetState(state) {
      Object.assign(state, defaultState())
    }
  },

  state: defaultState(),

  modules: {
  }
}
